import {Button, ButtonGroup, closeDialog} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {BULK_PACKAGE_VERIFICATION_PROMPT} from '../constants/BulkPackageVerificationPrompt';

interface BulkPackageVerificationPromptProps extends RequiredTestIdProps {
  onCompleteVerification: (code: 'NORMALIZE' | 'DONT') => void;
}

export function BulkPackageVerificationPrompt(props: BulkPackageVerificationPromptProps) {
  return (
    <VStack spacing={4}>
      <Text>{i18n.t('entity.warehouse.labels.bulkPackageVerificationText')}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          title={i18n.t('entity.warehouse.actions.returnToEdit')}
          onClick={() => closeDialog(BULK_PACKAGE_VERIFICATION_PROMPT)}
          data-testid={suffixTestId('actions.returnToEdit', props)}
        />
        <Button
          variant="secondary"
          title={i18n.t('entity.warehouse.actions.dontNormalize')}
          onClick={() => props.onCompleteVerification('DONT')}
          data-testid={suffixTestId('actions.dontNormalize', props)}
        />
        <Button
          variant="primary"
          title={i18n.t('entity.warehouse.actions.normalize')}
          onClick={() => props.onCompleteVerification('NORMALIZE')}
          data-testid={suffixTestId('actions.normalize', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
